import * as T from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'
import s from './Tooltip.module.css'

export function Tooltip({ label, children, open, defaultOpen, onOpenChange }: {
  label: ReactNode
  children: ReactNode
  /* OPTIONAL passthroughs to Radix, so a host, a gallery or a design capture
     can SHOW the tooltip without synthesising a hover (#2406 kit-defects-b —
     the Claude Design sync could not render it open). Absent, the tooltip is
     uncontrolled exactly as before. */
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
}) {
  return (
    <T.Provider delayDuration={300}>
      <T.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
        <T.Trigger asChild>{children}</T.Trigger>
        <T.Portal>
          <T.Content className={s.content} sideOffset={6}>
            {label}
            <T.Arrow className={s.arrow} />
          </T.Content>
        </T.Portal>
      </T.Root>
    </T.Provider>
  )
}
